module.exports = __webpack_public_path__ + "static/media/narrow-gate-games.93b9186e.png";